export default "__VITE_ASSET__CuGm_tZW__"